import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import customerConfig from './modules/customerConfig'
import files from './modules/files'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
      common,
      customerConfig,
      files
    },
    strict: process.env.VUE_APP_NODE_ENV !== 'production',
})

export default store